import React from 'react'
import "../css/profile.css"
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Link } from 'react-router-dom'

const Profile = () => {

    

    const navigate = useNavigate();
    const [user, setUser] = useState({});
    async function callAboutPage() {
        const res = await fetch("https://petme.onrender.com/about", {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("token")
            },
            credentials: "include"
        });



        const data = await res.json()
        setUser(data)
        if (res.status !== 200) {
            navigate("/login");
        }
    }

    useEffect(() => {
        callAboutPage();
    }, []);

    const [visible, setVisible] = React.useState(false);
    return (
        <div>
            <button className="profile-btn" onClick={() => setVisible(!visible)}>{visible ? <i className="profile-image-icon fa-solid fa-user"></i> : <i className="profile-image-icon fa-solid fa-user"></i>}</button>
            {visible &&
                <div className="profile-div" >
                    <i className="profile-profileImg fa-solid fa-user"></i>
                    {/* <img class="profile-profileImg" src={props.userImg} alt="profileImage" /> */}
                    <h4 className="profile-data-name">{user.firstname} {user.name}</h4>
                    <p className="profile-data emailProfile">Email Address<br /><span className="profile-email-value">{user.email}</span></p>
                    <Link id="viewProfileNavlink" className="viewProfile-navlink" to={`/userProfile/${user.email}`} >
                        <button type="button" class="viewProfileBtn">VIEW PROFILE</button>
                    </Link>
                </div>

            }
        </div >
    );
};




export default Profile


